import { IAffiliatesColumn } from "./interfaces";
import { formatToYYYYMMDD } from "./utils";
import { LeadStatusCell } from "./table/StatusWithDot";
import { RemanDaysCell } from "./table/RemainDaysCell";

import CardIcon from "../../../assets/profile/icons/card.svg";
import UserIcon from "../../../assets/profile/icons/user.svg";
import DynamicsIcon from "../../../assets/profile/icons/dynamics.svg";

export const QUERY_PARAM_LEAD_STATUS = "leadStatus";
export const QUERY_PARAM_DATE_RANGE_START = "dateStart";
export const QUERY_PARAM_DATE_RANGE_END = "dateEnd";

export const DEFAULT_LEAD_STATUS = "all";
export const DEFAULT_SORT_FIELD = "registrationDate";
export const DEFAULT_SORT_DIRECTION = "desc";

export const DEFAULT_SORT = {
  direction: DEFAULT_SORT_DIRECTION,
  field: DEFAULT_SORT_FIELD,
};

const today = new Date();
const lastWeek = new Date();
lastWeek.setDate(today.getDate() - 7);

export const DEFAULT_DATE_RANGE_START = formatToYYYYMMDD(lastWeek);
export const DEFAULT_DATE_RANGE_END = formatToYYYYMMDD(today);

export const DEFAULT_DATE_RANGE = {
  start: DEFAULT_DATE_RANGE_START,
  end: DEFAULT_DATE_RANGE_END,
};

//TABLE
export const affiliatesTableColumns: readonly IAffiliatesColumn[] = [
  {
    id: "leadName",
    label: "leadName",
  },
  {
    id: "registrationDate",
    label: "registrationDate",
  },
  {
    id: "endDate",
    label: "endDate",
    renderCell: RemanDaysCell,
  },
  {
    id: "leadStatus",
    label: "leadStatus",
    renderCell: LeadStatusCell,
  },
  {
    id: "earned",
    label: "earned",
  },
  {
    id: "pending",
    label: "pending",
  },
];

export const createStatisticsElements = (
  totalEarning: number | string,
  totalNumberOfLeads: number,
  activeLeadsCount: number,
  isMobile: boolean
) => [
  {
    title: "total_earnings",
    total: "₪" + totalEarning,
    percents: "2.45%",
    icon: CardIcon,
  },
  {
    title: isMobile ? "total_number" : "total_number_of_leads",
    total: totalNumberOfLeads,
    percents: "2.45%",
    icon: UserIcon,
  },
  {
    title: "active_leads",
    total: activeLeadsCount,
    percents: "2.45%",
    icon: DynamicsIcon,
  },
];
